import { render } from "./Footer.vue?vue&type=template&id=6d61ea63"
const script = {}

import exportComponent from "F:\\Programs\\Herd\\posLaravel12\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__